import * as React from 'react';
import { PropsWithChildren } from 'react';
import * as styles from './styles.module.css';

import '../../styles/reset.css';
import '../../styles/style.css';

export const Layout = ({ children }: PropsWithChildren<{}>) => {
	return (
		<>
			<div className={`${styles.fullScreenBackground} ${styles.gradientWrapper}`}>
				<div className={`${styles.fullScreenBackground} ${styles.gradient1}`}></div>
				<div className={`${styles.fullScreenBackground} ${styles.gradient2}`}></div>
				<div className={`${styles.fullScreenBackground} ${styles.gradient3}`}></div>
			</div>
			{children}
		</>
	);
};
